export class ApiDocumentToken {
  static IApiDocumentRepository = Symbol("IApiDocumentRepository");
  static ApiDocumentUseCase = Symbol("ApiDocumentUseCase");
  static ApiDocumentViewModel = Symbol("ApiDocumentViewModel");
}
